import { Pipe, PipeTransform } from '@angular/core';
import { EmulatorMessage } from '../../../../../shared/models';

@Pipe({
  name: 'getListContent'
})
export class GetListContentPipe implements PipeTransform {

  transform(emulatorMessage: EmulatorMessage, ...args: string[]): any {
    const contentType = args[0];
    console.log('emulator', emulatorMessage);
    if (contentType === 'OneApiButtonEvent') {
      return {
        clientMessageId: emulatorMessage.channelPayload['messages'][0]['clientMessageId'],
        mediaMetaData: emulatorMessage.mediaMetaData,
        ...emulatorMessage.channelPayload['messages'][0]['button'],
      };
    }
    if (contentType === 'OneApiListPickerEvent') {
      return {
        clientMessageId: emulatorMessage.channelPayload['messages'][0]['clientMessageId'],
        ...emulatorMessage.channelPayload['messages'][0]['listPicker']
      };
    }
  }

}
